import React from 'react';
import { SvgIcon } from 'components/SvgIcon';
import { IThankYou } from 'services/ThankYouService';
import { enPaymentMethod } from 'enums/enPaymentMethod';

interface IProps {
  model: IThankYou;
}
const Job: React.FC<IProps> = ({ model }) => {
  const textInformation = {
    [enPaymentMethod.BANKSLIP]: (
      <p>
        Este é um serviço oferecido por {model.content.producerName}, assim que o boleto for pago as instruções chegarão no seu <b>e-mail</b>.
        Enquanto isso, confirme os seus dados.
      </p>
    ),
    [enPaymentMethod.PAGDIVIDIDO]: (
      <p>
        Este é um serviço oferecido por {model.content.producerName}. Fique atento, você receberá um <b>SMS</b> para finalizar o processo. Após
        finalizado as instruções estará disponível no seu&nbsp;
        <b>e-mail</b>. Enquanto isso, confirme os seus dados.
      </p>
    )
  };

  return (
    <React.Fragment>
      <div className={'message'}>
        {textInformation[model.paymentResult.paymentMethod] ?? (
          <p>
            Este é um serviço oferecido por {model.content.producerName}, estamos preparando com carinho as instruções e enviaremos no seu&nbsp;
            <b>e-mail</b>. Enquanto isso, confirme os seus dados.
          </p>
        )}
      </div>
      <div className={'data'}>
        <div className={'user'}>
          <div className={'user'}>
            <p>
              <SvgIcon name="user" />
              <span>{model.studdent ? model.studdent.name : model.user.name}</span>
            </p>
            <p>
              <SvgIcon name="email" />
              <span>{model.studdent ? model.studdent.email : model.user.email}</span>
            </p>
          </div>
        </div>
      </div>
      <div className={'alert'}>
        Em caso de dúvidas, ou se você precisar de suporte, entre em contato com o vendedor pelo e-mail <b>{model.content.producerEmail}</b>.
      </div>
    </React.Fragment>
  );
};

export default React.memo(Job);
